import CreanceVueProduits from '@/components/comptable/creance/creance-vue-produits'
import CreanceVuePatients from '@/components/caisse/factures/creance-patients'
import CreanceAssurance from '@/components/comptable/creance/creance-assurance'
import Prestation from "@/components/comptable/prestations-exploitations/prestation"

export default {
    name: 'creance',
    components: {
        CreanceVueProduits, CreanceVuePatients, Prestation,
        CreanceAssurance 
    },
    props: [],
    data() {
        return {
            config_to_show: 'vue-produits',

            is_recap: true,
            montant_en_lettre: '',
            montant_total: 0,
            can_print: false,
            is_month: false,
            liste_produits_creances: [],
            current_date_filter: {},
            curr_month: "",

        }
    },

    computed: {
        
    },

    mounted() {
        
    },

    methods: {
        changeTab(tab_to_show) {
            this.config_to_show = tab_to_show
        },

        printCreances(print_data) {
            this.is_recap = print_data.is_recap
            this.can_print = true
            this.liste_produits_creances = print_data.liste_produits_creances
            this.montant_total = print_data.montant_total
            this.montant_en_lettre = print_data.montant_en_lettre
            this.current_date_filter = print_data.current_date_filter
            this.is_month = print_data.is_month
            this.curr_month = print_data.curr_month

            setTimeout(() => {
                window.print()
                this.can_print = false
            }, 500);
        },
    }
}